import React from 'react';
import {
  Create,
  SaveButton,
  SimpleForm,
  Toolbar,
  useNotify,
  useRedirect,
} from 'react-admin';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';
import FormRecurringSend from '../../components/FormRecurringSend';
import { buildSavedMessage } from '../../components/FormRecurringSend/nextSend';
import { daysOfTheWeek } from '../../constants';
import { track, EVENTS } from '../../lib/analytics';

const toolbarSx = {
  justifyContent: 'space-between'
};

const defaultWeekSchedule = daysOfTheWeek.map(day => ({
  dayOfTheWeek: day.id,
  startTime: null,
  isActive: false,
}));

const CreateRecurringSend: React.FC = ({ ...props }) => {
  const notify = useNotify();
  const redirect = useRedirect();

  const CreateToolbar = (props) => {
    return (
      <Toolbar {...props} sx={toolbarSx}>
        <SaveButton />
      </Toolbar>
    );
  };

  return (
    <Permission permission={PERMISSIONS.UNIFIED_SEND}>
      <Create
        {...props}
        title="Cadastrar novo envio recorrente"
        mutationOptions={{
          onSuccess: (data: any, variables: any) => {
            const active_days = (variables?.data?.weekSchedule ?? []).filter((d: any) => d?.isActive).length;
            track(EVENTS.RECURRING_SEND_CREATED, {
              push_notification: !!variables?.data?.pushNotification,
              is_active: !!variables?.data?.isActive,
              active_days,
            });
            const nextSendMessage = buildSavedMessage(variables?.data, data?.todaySendAt);
            if (nextSendMessage) {
              notify(`Envio recorrente criado. ${nextSendMessage}`, { type: 'info', autoHideDuration: 6000 });
            } else {
              notify('ra.notification.created', { type: 'info', messageArgs: { smart_count: 1 } });
            }
            redirect('list', 'chains/chainId/recurring-send');
          },
        }}
      >
        <SimpleForm
          toolbar={<CreateToolbar />}
          defaultValues={{
            pushNotification: true,
            isActive: true,
            weekSchedule: defaultWeekSchedule,
          }}
        >
          <FormRecurringSend />
        </SimpleForm>
      </Create>
    </Permission>
  );
};

export default CreateRecurringSend;
